// See https://github.com/bigskysoftware/htmx/issues/1690
import htmx from 'htmx.org';
window.htmx = htmx;